module.exports = (__parcel__import__("i7NGI")).then(() => parcelRequire('lmhgI'));